import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className=" shadow">
      <div className="container mx-auto px-6 py-4">
        <nav className="text-sm text-gray-500 ">
          <Link to="/"> Accueil {">"} </Link>{" "}
          <span className="text-gray-800 font-semibold">Calendrier</span>
        </nav>
        <h1 className="text-3xl font-bold mt-2">Novembre 2024</h1>
      </div>
    </header>
  );
};

export default Header;
